export class LoadAppPHPSettingsError extends Error {}
